/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    // handle DOMContentLoaded event
    function get_nodes_containing_text(selector, text) {
      const elements = [...document.querySelectorAll(selector)];
      return elements.filter(
        (element) =>
          element.childNodes[1] &&
          element.childNodes[1].innerHTML &&
          RegExp(text, "u").test(element.childNodes[1].innerHTML.trim())
      );
    }
    // Called on load and when a radio is clicked, should be ok to run across all everytime
    function setActiveRadio() {
      radios = document.querySelectorAll(
        "div.bold_option_set > div.bold_option.bold_option_radio > span.bold_option_element > span.bold_option_value > label > span > input[type=radio]"
      );
      radios.forEach(function (radio) {
        if (radio.checked) {
          radio.parentElement.parentElement.classList.add("active");
        } else {
          radio.parentElement.parentElement.classList.remove("active");
        }
      });
    }
    // Updates bold hidden size when called
    function updateSize(sizeInput) {
      size = sizeInput.value;
      boldSelector =
        sizeInput.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
          ".bold_options > div.bold_option_set > div.bold_option.bold_option_radio.hidden-bold-offscreen > span.bold_option_element > span.bold_option_value > label > span > input[value='" +
            size +
            "']"
        );
      //             console.log(boldSelector);
      boldSelector.click();
    }
    function boldOptionsLoaded() {
      //            productCount = document.querySelectorAll('.product-form, .product-item__info').length;
      boldOptionSets = [...document.querySelectorAll("div.bold_options")];
      boldOptionSetsCount = boldOptionSets.length;
      boldOptionCount = boldOptionSets.filter(
        (element) =>
          element.classList &&
          element.classList.contains("bold_options_loaded") &&
          element.hasChildNodes()
      ).length;
      //             console.log(boldOptionSetsCount, boldOptionCount, boldOptionSetsCount === boldOptionCount)
      return boldOptionCount > 0;
      //return boldOptionSetsCount === boldOptionCount;
    }
    function setUpBold() {
      //             console.log("Bold",boldOptionsLoaded());

      // On Doc Ready hide all hidden fields
      try {
        nodes = get_nodes_containing_text(
          "div.bold_option_set > div.bold_option.bold_option_radio",
          "_Hidden Size"
        );
        nodes.forEach(function (node) {
          node.classList.add("hidden-bold-offscreen");
        });
      } catch (error) {
        console.error(error);
      }
      // On load updates all bold hidden fields
      try {
        sizeInputs = document.querySelectorAll(
          "[data-swatch-name='size'] input[type=radio]:checked"
        );
        sizeInputs.forEach(function (sizeInput) {
          updateSize(sizeInput);
        });
      } catch (error) {
        console.error(error);
      }
      // Bind to change event when size changes
      try {
        sizeInputs = document.querySelectorAll(
          "[data-swatch-name='size'] input[type=radio]"
        );
        sizeInputs.forEach((sizeInput) =>
          sizeInput.addEventListener("change", () => updateSize(sizeInput))
        );
      } catch (error) {
        console.error(error);
      }
      // Bind to change event when bold option clicked
      try {
        boldOptions = document.querySelectorAll(
          "div.bold_option_set > div.bold_option.bold_option_radio > span.bold_option_element > span.bold_option_value > label"
        );
        boldOptions.forEach((boldOption) =>
          boldOption.addEventListener("change", () => setActiveRadio())
        );
      } catch (error) {
        console.error(error);
      }
      //             console.log("Bold",boldOptionsLoaded());
      setActiveRadio();
    }
    function checkIsReady(count) {
      if (boldOptionsLoaded() === false && count < 20) {
        //                console.log("not ready", count++)
        window.setTimeout(function () {
          checkIsReady(count);
        }, 500);
      } else {
        setUpBold();
      }
    }
    checkIsReady(0);
  });
})();
